module.exports = __webpack_public_path__ + "Roboto-Medium-webfont.a5692169fc006c84bb7c.svg";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/fonts/roboto/Roboto-Medium-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Medium-webfont.svg
// module chunks = 2